import { jsx as _jsx } from "react/jsx-runtime";
import { useDndContext, useDroppable } from "@dnd-kit/core";
import { memo, useMemo } from "react";
import { KanbanColumnContainer } from "~/components/KanbanView/shared/KanbanColumnContainer";
import { DndItemType, isDndDroppableKanbanColumnData, isDndSortableKanbanColumnData, isDndSortableKanbanItemData } from "~/types/DndKit";
import { getDroppableKanbanColumnKey } from "~/utils/getDndKeys";
/** This component allows us to recognize the movement from column to column */ export const DndDroppableKanbanColumn = /*#__PURE__*/ memo((param)=>{
    let { children, header, isLoading, kanbanColumnId } = param;
    const { active, over } = useDndContext();
    const activeData = active === null || active === void 0 ? void 0 : active.data.current;
    const overData = over === null || over === void 0 ? void 0 : over.data.current;
    const variant = useMemo(()=>{
        if (isDndSortableKanbanItemData(activeData)) {
            if (isDndSortableKanbanItemData(overData) && overData.currentKanbanColumnId === kanbanColumnId) {
                return "activeDropzoneWithChildren";
            } else if (isDndDroppableKanbanColumnData(overData) && overData.kanbanColumnId === kanbanColumnId && activeData.currentKanbanColumnId !== kanbanColumnId) {
                return "activeDropzone";
            }
        }
        if (isDndSortableKanbanColumnData(activeData) && activeData.kanbanColumnId === kanbanColumnId) {
            return "withDragOverlay";
        }
        return undefined;
    }, [
        kanbanColumnId,
        activeData,
        overData
    ]);
    const data = useMemo(()=>({
            dndType: DndItemType.kanbanDroppableColumn,
            kanbanColumnId
        }), [
        kanbanColumnId
    ]);
    const { setNodeRef } = useDroppable({
        id: getDroppableKanbanColumnKey(kanbanColumnId),
        data
    });
    return /*#__PURE__*/ _jsx(KanbanColumnContainer, {
        header: header,
        isLoading: isLoading,
        variant: variant,
        ref: setNodeRef,
        children: children
    });
});
DndDroppableKanbanColumn.displayName = "DndDroppableKanbanColumn";
